import PasswordResetConfirmation from './PasswordResetConfirmation'

export default PasswordResetConfirmation
